export default "__VITE_ASSET__68183ba8__"